import {SpecialsComponent} from '../../../js/custom-components/specials/specials-component';
class SpecialsWidgetComponent extends React.PureComponent{	
		
	render(){				
		return (	
			<div className={"notification__widget__block " + (this.props.notificationWidgetActive ? 'active' : '')}>
				<div className="notification__widget__layer">
				</div>
				<div className="notification__widget__layer2">
					<div className="notification__widget__container">
						<button onClick={this.props.onCloseClick}>
							<i className="fa icon-cancel fa-2x" aria-hidden="true"></i>
						</button>
						<h2 className="notification__widget__block__title">-specials!</h2>
						<p className="notification__widget__scrolltip">-scroll box for more</p>
						<SpecialsComponent />
					</div>
				</div>
			</div>
		);
	}
}
export { SpecialsWidgetComponent };


// WEBPACK FOOTER //
// in/js/custom-components/specials/specials-widget-component.js